import React from 'react'
import Navbar from '../navbar/Navbar'

export default function Header() {
  return (
    <header className='header'>
        <Navbar/>
    </header>
  )
}
